import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5737b82a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5737b82a')) {
      api.createRecord('5737b82a', component.options)
    } else {
      api.reload('5737b82a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5737b82a&", function () {
      api.rerender('5737b82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l4ybcO0mv4Za/JS/comp/openstreetmap.vue"
export default component.exports